import React from 'react';

import { useAuth } from 'hooks/useAuth';
import { usePlaybackTracking } from 'hooks/usePlaybackTracking';
import { usePlayer } from 'hooks/usePlayer';
import { useStoryListen } from 'hooks/useStoryListen';

// Needed for conditional rendering of the hook
const StoryListenHook = ({ storyId }: { storyId: string }) => {
  useStoryListen(storyId);

  return <></>;
};

const StoryListenHandler = () => {
  usePlaybackTracking();
  const { currentlyPlaying } = usePlayer();
  const { user } = useAuth();

  return currentlyPlaying?.audioType === 'audio' && user ? (
    <StoryListenHook storyId={currentlyPlaying.id} />
  ) : null;
};

export default StoryListenHandler;
